import { useEffect } from 'react'
import {
  PaginationDirection,
  useSalaryTableStore,
} from '@/modules/salary/salary-table-context'
import { useCustomPush } from '@/lib/client/navigation'
import { useSearchParams } from 'next/navigation'
import { SalaryType } from '@/lib/generated/graphql-types'
import { SalaryFilterParam } from '../constants'

/**
 * Executed after salaries is re-fetched and checks if user navigated using salary details
 * arrows (paginationDirection) to set the first or last salary details to open
 * panel.
 * @param salaries
 */
export function useSalaryDetailsNavigation({
  salaries,
}: {
  salaries: SalaryType[]
}) {
  const push = useCustomPush()
  const searchParams = useSearchParams()
  const salaryIdParam = searchParams.get(SalaryFilterParam.salaryId)
  const paginationDirection = useSalaryTableStore(
    (state) => state.paginationDirection,
  )
  const setPaginationDirection = useSalaryTableStore(
    (state) => state.setPaginationDirection,
  )

  useEffect(() => {
    const isForward = paginationDirection === PaginationDirection.Forward
    if (
      paginationDirection &&
      salaries[isForward ? salaries.length - 1 : 0].salaryId !== salaryIdParam
    ) {
      setPaginationDirection(null)
      // forward selects first of next list, backward last of previous list
      push({ salaryId: salaries[isForward ? 0 : salaries.length - 1].salaryId })
    }
  }, [
    salaries,
    paginationDirection,
    setPaginationDirection,
    push,
    salaryIdParam,
  ])
}
